<template>
    <div class="room-setting-chat-component p-5">
        <div class="room-setting-content-box">
            <h6 class="room-setting-content-title">{{ $t("setting.etc.language.title") }}</h6>
            <div class="room-setting-content-text-box">
                <p class="room-setting-content-text">{{ $t("setting.etc.language.explain") }}</p>
                <p class="room-setting-content-text">{{ $t("setting.etc.language.list", { '0' : `${$t('common.ko')}, ${$t('common.en')}`}) }}</p>
            </div>
            <div class="room-setting-input-box">
                <label class="room-setting-label">
                    <GrmSimpleSelect
                      :value="$i18n.locale"
                      :options="[
                    { value: 'ko', title: $t('common.ko') },
                    { value: 'en', title: $t('common.en') },
                  ]"
                      @input="(value) => onChangeLocale(value)"
                    />
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations} from "vuex";
import {RoomInfo} from "@/core/api/room.info.api";
import GrmSimpleSelect from "@/components/Common/select/GrmSimpleSelect.vue";

export default {
  components: {
    GrmSimpleSelect
  },
  data(){
    return{
      isChatMode: false
    }
  },
  computed:{
    ...mapGetters('roomSetting', ['params']),
      ...mapGetters('room', ['roomInfo']),
  },
  mounted(){
    this.isChatMode = this.params.useChat ? !this.isChatMode : this.isChatMode;
  },
  methods:{
    ...mapMutations('roomSetting', ['CHANGE_SETTING_DATA']),
    onChangeLocale(locale){
      this.$i18n.locale = locale
      localStorage.setItem('grm_locale', this.$i18n.locale)
      RoomInfo.setLocaleMsg(this.$i18n.locale, this.roomInfo)
    },
  }
}
</script>